import { Environment } from '@/env';

const ENCRYPTION_KEY = Environment.ACCESS_KEY;

// Synchronous encryption utilities
export const encrypt = (text: string): string => {
  const result = [];
  for (let i = 0; i < text.length; i++) {
    const charCode =
      text.charCodeAt(i) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length);
    result.push(String.fromCharCode(charCode));
  }
  return btoa(result.join(''));
};

export const decrypt = (encryptedText: string): string => {
  const text = atob(encryptedText);
  const result = [];
  for (let i = 0; i < text.length; i++) {
    const charCode =
      text.charCodeAt(i) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length);
    result.push(String.fromCharCode(charCode));
  }
  return result.join('');
};
